import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const AdminSidebar = ({ sidebarOpen }) => {
  const [admin, setAdmin] = useState({
    name: "Admin",
    designation: "",
  });

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      const decoded = jwtDecode(token);
      setAdmin({
        name: decoded.name || "Admin",
        designation: decoded.designation || "",
        role: decoded.role || "",
      });
    } catch (err) {
      console.error("Invalid token");
    }
  }, []);

  return (
    <aside
      className={`admin-sidebar app-sidebar bg-body-secondary shadow ${
        sidebarOpen ? "open" : "closed"
      }`}
      data-bs-theme="dark"
    >
      <div className="sidebar-brand">
        <Link
          to="dashboard"
          className="brand-link d-flex align-items-center gap-2"
        >
          <img
            src="/img/logo.png"
            alt="Logo"
            className="brand-image opacity-75 shadow"
            style={{ width: "35px", height: "35px" }}
          />

          <div className="d-flex flex-column">
            {admin.designation && (
              <small style={{ fontSize: "20px", color: "white" }}>
                {admin.designation}
              </small>
            )}
          </div>
        </Link>
      </div>

      <div className="sidebar-wrapper">
        <nav>
          <ul className="nav nav-pills flex-column gap-1">
            <li className="nav-item">
              <NavLink
                to="dashboard"
                className={({ isActive }) =>
                  `nav-link ${isActive ? "active" : ""}`
                }
              >
                <i className="bi bi-speedometer2 me-2"></i>
                Dashboard
              </NavLink>
            </li>

            {(admin.role === "1" ||
              admin.role === "2" ||
              admin.role === "3") && (
              <li className="nav-item">
                <NavLink
                  to="adminPage"
                  className={({ isActive }) =>
                    `nav-link ${isActive ? "active" : ""}`
                  }
                >
                  <i className="bi bi-person-gear me-2"></i>
                  Admin
                </NavLink>
              </li>
            )}

            <li className="nav-item">
              <NavLink
                to="totalStudents"
                className={({ isActive }) =>
                  `nav-link ${isActive ? "active" : ""}`
                }
              >
                <i className="bi bi-people me-2"></i>
                Total Students
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to="formSubmitted"
                className={({ isActive }) =>
                  `nav-link ${isActive ? "active" : ""}`
                }
              >
                <i className="bi bi-file-earmark-check me-2"></i>
                Form Submitted
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to="verifiedStudents"
                className={({ isActive }) =>
                  `nav-link ${isActive ? "active" : ""}`
                }
              >
                <i className="bi bi-check-circle-fill me-2"></i>
                Verified Students
              </NavLink>
            </li>

            {(admin.role === "1" ||
              admin.role === "2" ||
              admin.role === "3") && (
              <li className="nav-item">
                <NavLink
                  to="approvedStudents"
                  className={({ isActive }) =>
                    `nav-link ${isActive ? "active" : ""}`
                  }
                >
                  <i className="bi bi-check-circle-fill me-2"></i>
                  Approved Students
                </NavLink>
              </li>
            )}

            <li className="nav-item">
              <NavLink
                to="discrepencyStudents"
                className={({ isActive }) =>
                  `nav-link ${isActive ? "active" : ""}`
                }
              >
                <i className="bi bi-exclamation-triangle-fill me-2"></i>
                Discrepency Students
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to="rejectedStudents"
                className={({ isActive }) =>
                  `nav-link ${isActive ? "active" : ""}`
                }
              >
                <i className="bi bi-x-circle-fill me-2"></i>
                Rejected Students
              </NavLink>
            </li>
          </ul>
        </nav>
      </div>
    </aside>
  );
};

export default AdminSidebar;
